import { CHIPS_COLORS } from './colors';
import { ChipType } from '../types';

export const CHIPS_MIN_100: ChipType[] = [
  {
    color: CHIPS_COLORS.BLUE,
    value: 100,
  },
  {
    color: CHIPS_COLORS.YELLOW,
    value: 200,
  },
  {
    color: CHIPS_COLORS.RED,
    value: 500,
  },
  {
    color: CHIPS_COLORS.VIOLET,
    value: 1e3,
  },
  {
    color: CHIPS_COLORS.GREEN,
    value: 2e3,
  },
  {
    color: CHIPS_COLORS.ORANGE,
    value: 5e3,
  },
  {
    color: CHIPS_COLORS.LIGHT_BLUE,
    value: 10e3,
  },
  {
    color: CHIPS_COLORS.SCARLET,
    value: 20e3,
  },
  {
    color: CHIPS_COLORS.PURPLE,
    value: 50e3,
  },
];
